import { useEffect } from 'react';
import { useScrollLock } from '~/shared/hooks/useScrollLock';

// Every RefinementDropdown instance calls this with its own open state. Desktop can have several
// panels mounted at once (Brand, Serie, Farve...), each with independent open state, so we count
// how many are open locally and only call the shared lock()/unlock() at the 0-to-1 and 1-to-0
// transitions. That keeps this feature's usage of the shared lock symmetric — exactly one lock()
// paired with exactly one unlock() — without touching useScrollLock itself or its other consumers.
let openPanelCount = 0;

export const useRefinementDropdownScrollLock = (isOpen: boolean) => {
    const { lock, unlock } = useScrollLock();

    useEffect(() => {
        if (!isOpen) return;

        openPanelCount += 1;
        if (openPanelCount === 1) lock();

        return () => {
            openPanelCount = Math.max(0, openPanelCount - 1);
            if (openPanelCount === 0) unlock();
        };
    }, [isOpen, lock, unlock]);
};
